import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

document.addEventListener('DOMContentLoaded', () => {
    const swiperSliders = document.querySelectorAll('.swiper-main');
    if (!!swiperSliders) {
        swiperSliders.forEach((container) => {
            const thumbs = container.nextSibling.children[0];
            new Swiper(thumbs, {
                spaceBetween: 2,
                slidesPerView: 'auto',
                freeMode: true,
                watchSlidesProgress: true,
            })
            new Swiper(container, {
                loop: true,
                thumbs: {
                    swiper: thumbs,
                },
                on: {
                    slideChange: (sw) => {
                        sw.slides.forEach((slide, index) => {
                            const video = slide.querySelector('video');
                            if (index !== sw.activeIndex && video) {
                                video.pause();
                            }
                        });

                        const activeSlide = sw.slides[sw.activeIndex];
                        const activeVideo = activeSlide?.querySelector('video');
                        if (activeVideo) {
                            activeVideo.muted = true;
                            activeVideo.play().catch(() => {
                                // ignore errors
                            });
                        }
                    }
                },
            });
        });
    }

    const swiperProjects = document.querySelectorAll('.project-list--slider');
    if (!!swiperProjects) {
        swiperProjects.forEach((container) => {
            new Swiper(container, {
                spaceBetween: 2,
                slidesPerView: 'auto',
                loop: true
            });
        })
    }
});


window.addEventListener('scroll', function() {
    const logo = document.querySelector('.site-logo');
    if (window.scrollY > 0) {
        logo.classList.add('hidden');
    }
});
